import { get, isNull } from 'lodash-es'
// import { CONSTANTS } from './index'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules.js'
import CONSTANTS from './constants'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types'
// import { TYPES as ACTION_TYPES } from './actions'
import { TYPES as MUTATION_TYPES } from './mutations'
import { TYPES as ACTION_TYPES } from './actions'
import { TYPES as GETTER_TYPES } from './getters'
// import { SETS } from './state'
import PUSHER_CONSTANTS from './pusher-constants'
import { getChannel } from '@/js/plugins/ws/vue-dp-echo/helper.js'
import {
  TYPE as MESSAGING_TYPE,
  TYPE_INFO as MESSAGING_TYPE_INFO,
} from '@/js/helper/messaging-constants.js'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'

const CHANNEL_NAMES = {
  ANNOUNCEMENTS: 'announcements',
  USER: 'User.{id}',
}

const EVENT_NAMES = {
  [CHANNEL_NAMES.ANNOUNCEMENTS]: {
    ANNOUNCEMENT: '.Announcement',
  },
  [CHANNEL_NAMES.USER]: {
    AVAILABILITY: `.${MESSAGING_TYPE.AVAILABILITY}`,
    AVAILABILITY_LOW: `.${MESSAGING_TYPE.AVAILABILITY_LOW}`,
    AVAILABILITY_AGAIN: `.${MESSAGING_TYPE.AVAILABILITY_AGAIN}`,
    BLOCKINGREASONS_NEW: `.${MESSAGING_TYPE.BLOCKINGREASONS_NEW}`,
    BACKORDER_SHIFT: `.${MESSAGING_TYPE.BACKORDER_SHIFT}`,
    SYSTEM_LOGOUT: `.${MESSAGING_TYPE.SYSTEM_LOGOUT}`,
    SYSTEM_SUPPORTACCESSLOGOUT: `.${MESSAGING_TYPE.SYSTEM_SUPPORTACCESSLOGOUT}`,
    SYSTEM_SUPPORTACCESSKICK: `.${MESSAGING_TYPE.SYSTEM_SUPPORTACCESSKICK}`,
  },
}

const USER_EVENTS = [
  EVENT_NAMES[CHANNEL_NAMES.USER].AVAILABILITY,
  EVENT_NAMES[CHANNEL_NAMES.USER].AVAILABILITY_LOW,
  EVENT_NAMES[CHANNEL_NAMES.USER].AVAILABILITY_AGAIN,
  EVENT_NAMES[CHANNEL_NAMES.USER].SYSTEM_LOGOUT,
  EVENT_NAMES[CHANNEL_NAMES.USER].SYSTEM_SUPPORTACCESSLOGOUT,
  EVENT_NAMES[CHANNEL_NAMES.USER].SYSTEM_SUPPORTACCESSKICK,
  EVENT_NAMES[CHANNEL_NAMES.USER].BLOCKINGREASONS_NEW,
  EVENT_NAMES[CHANNEL_NAMES.USER].BACKORDER_SHIFT,
]

export const addNotification = (store, notification) => {
  store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.ADD_NOTIFICATION}`, notification)
}

const announcementEventFunctionFactory = store => (eventName, data) => {
  console.debug(eventName, data)
  if (eventName === EVENT_NAMES[CHANNEL_NAMES.ANNOUNCEMENTS].ANNOUNCEMENT) {
    addNotification(store, {
      type: 'info',
      ...data,
    })
  }
}

const personalEventFunctionFactory = store => (eventName, data) => {
  console.debug(eventName, data)
  if (USER_EVENTS.includes(eventName)) {
    const eventConfig = get(MESSAGING_TYPE_INFO, data?.type, {})

    addNotification(store, {
      ...eventConfig,
      ...data,
    })
  }

  maybeRefreshMessagingStatus(data, store)
}

const CHANNELS = [
  { name: CHANNEL_NAMES.ANNOUNCEMENTS, eventFactory: announcementEventFunctionFactory },
  { name: CHANNEL_NAMES.USER, eventFactory: personalEventFunctionFactory },
]

// const reconnectTimeout = 5000

// const reconnect = Echo => {
//   console.debug(`Echo reconnect…`)
//   Echo.connect()
// }

const bindConnectionState = ({ store, Echo }) => {
  // let timeout
  Echo.connector.pusher.connection.bind('state_change', function (states) {
    // const prevState = states.previous
    const currState = states.current
    // console.log({ prevState, currState })
    store.commit(`${CONSTANTS.MODULE_ID}/${MUTATION_TYPES.SET_CONNECTION_STATE}`, currState)
    // if (PUSHER_CONSTANTS.NOT_CONNECTED_STATES.includes(currState)) {
    //   console.debug(`Echo ${currState}`)
    //   if (!timeout) {
    //     console.debug(`Echo reconnect in ${reconnectTimeout}`)
    //     timeout = setTimeout(() => {
    //       console.log(Echo)
    //       reconnect(Echo)
    //     }, reconnectTimeout)
    //   }
    // }
    if (currState === PUSHER_CONSTANTS.STATE.CONNECTED) {
      console.debug(`Echo ${currState}. Joining channels`)
      const userId = store.getters[`${STORE_MODULES.APP}/${APP_GETTERS.USERNAME}`]

      // console.log(Echo.getChannels())
      const currentChannels = Echo.getChannels()
      CHANNELS.forEach(channel => {
        const isPrivate = privateRegex.test(channel.name)
        const channelName = channel.name.replace(privateRegex, userId)
        const existingChannel = getChannel(currentChannels, channelName)
        console.debug(`${existingChannel ? 'Found' : 'Missing'} channel: ${channelName}`)
        if (!existingChannel) {
          console.debug(`Joining channel: ${channelName}`)
          Echo.join(channelName, { isPrivate })
          Echo.subscribeToAll(channelName, channel.eventFactory(store))
        }
      })
    }
  })
  // console.log(Echo)
  // Echo.join('announcements')
  // Echo.subscribe('announcements', '.Announcement', e => {
  //   console.log('Announcement')
  //   console.log(e)
  // })
  // console.log(Echo.getChannels())
  // return Echo?.connector?.pusher?.connection?.state
}

export const initWsStorePlugin = ({ store, Echo }) => {
  if (
    !store.getters[`${STORE_MODULES.APP}/${APP_GETTERS.HAS_ROLE}`](DP_ROLE.MESSAGING_SOCKET_R.p)
  ) {
    console.log('no websocket connection allowed')
    return
  }
  console.debug('initWsStorePlugin')
  initWatcher(store, Echo)
  initMessaging(store)
}

const privateRegex = /{id}/

export default function initWatcher(store, Echo) {
  // console.debug('initWatcher')

  bindConnectionState({ store, Echo })
}

export const initMessaging = store => {
  refreshMessagingStatus(store)

  if (CONSTANTS.STATUS_REFRESH_INTERVAL > 0) {
    setInterval(() => {
      if (store.getters[`${CONSTANTS.MODULE_ID}/${GETTER_TYPES.MESSAGING_INFO_PENDING}`]) {
        console.debug('Skip Messaging Status fetching.')
        return
      }
      refreshMessagingStatus(store)
    }, 1000 * 60 * CONSTANTS.STATUS_REFRESH_INTERVAL)
  }
}

export const maybeRefreshMessagingStatus = (event, store) => {
  if (isNull(get(event, 'userEventId', null))) {
    return
  }
  refreshMessagingStatus(store)
}

export const refreshMessagingStatus = store => {
  store
    .dispatch(`${CONSTANTS.MODULE_ID}/${ACTION_TYPES.GET_MESSAGES_INFO}`, {})
    .catch(e => console.log(e))
}
